import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { HelperService } from "./helper.service";
import { Functions, httpsCallable } from "@angular/fire/functions";
import * as viewmodels from '../viewmodels';
import * as models from '../models';
import { ReportDefinition } from "../viewmodels";

@Injectable()
export class DataSubmissionAnalyticsService {

    companyRef: AngularFirestoreCollection;

    constructor(
        private firestore: AngularFirestore,
        private helperService: HelperService,
        private functions: Functions,
    ) {
        this.companyRef = this.firestore.collection('companies');
    }

    async getDataSubmissionAnalytics(request: viewmodels.DataSubmissionAnalyticsRequest) {
        try {
            let method = httpsCallable(this.functions, 'getDataSubmissionAnalytics');

            let response = await method(request);

            let rawData = response.data;
            // If this works, then create your typed object from the raw data
            let retVal: models.Result<ReportDefinition[]> = rawData;
            return retVal;
        } catch (error) {
            console.error('Error in getDataSubmissionAnalytics:', error);
            throw error;
        }
    }
}
